export const prefixTranslation =
  'administration.externalCourses.participants.table.actions'
